import { AbstractProgramModel } from "@app/catalog-common";


export class SelectProgramMessage {
  selected: AbstractProgramModel;

  constructor(selected: AbstractProgramModel) {
    if(selected != undefined){
        this.selected =  selected;
    }
  }
}